//  接口文档地址  http://rap2.10niu.cn/repository/editor?id=138&mod=654&itf=4267

import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const questionAnswering = {
	// 智能问答模型详情 (后端走了路由模式)
	getDetail(id) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.ai}/aimodule/detail/${id}`,
			headers: config.headers
		});
	},
	// 删除智能问答模型 (后端走了路由模式)
	delete(id) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.ai}/aimodule/delete/${id}`,
			headers: config.headers
		});
	},
	// 新增智能问答模型 (后端走了路由模式)
	add(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.ai}/aimodule/add/`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 更新智能问答模型
	update(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.ai}/aimodule/update`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 根据用户身份获取模型列表 (后端走了路由模式)
	listByIdentity(identity) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.ai}/aimodule/list_by_identity/${identity}`,
			headers: config.headers
		});
	}
};
export default questionAnswering;
